import React, { Suspense, lazy, useEffect, useRef } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { auth } from './slices/userSlise';
import ProtectedRoute from './routing/ProtectedRoute';

import './App.css';
import NavBar  from './components/NavBar'
import Footer from './components/Footer'
import About from './pages/About'
import Gettoknow from './pages/Gettoknow'
import Solutions from './pages/Solutions'
import Contact from './pages/Contact'
import Contractors from './pages/Contractors'
import Main from './pages/Main'
import Lkabinet from './pages/Lkabinet'
import LkDashboard from './pages/LkDashboard'
import LkNotification from './pages/LkNotification'
import Risk from './pages/Risk'
import MyRisk from './pages/MyRisk'
import Dashboard from './pages/Dashboard'
import RiskTable from './pages/RiskTable'
import Forgot from './pages/ForgotPassword'
import Templates from './pages/Templates'
import ReviewRiskTable from './pages/ReviewRiskTable';
import WebsocketController from "./websocket/websocketController";
const ChatWindow = lazy(() => import('./components/ChatWindow/ChatWindow')) 


function App() {

	const { isLogin, currentUserId } = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const storedAuthToken = localStorage.getItem('authToken');
	useEffect(() => {
		if (storedAuthToken && !currentUserId) {
		  dispatch(auth({ storedAuthToken }))
			.unwrap()
			.catch(() => {
			  // Если авторизация не удалась
			  navigate('/');
			});
		}
	}, [dispatch, currentUserId, navigate, storedAuthToken]);

	/* for production version start => */
	useEffect(() => {
		if (isLogin) {
			WebsocketController.start();
		}
		return () => {
			WebsocketController.disconnect();
		};
	}, [isLogin]);
	/* for production version => end */

	/* for dev version 
	const websocketInitialized = useRef(false);
	useEffect(() => {
		if (isLogin && !websocketInitialized.current) {
			WebsocketController.start();
			websocketInitialized.current = true;
		}
		return () => {
			WebsocketController.disconnect();
			websocketInitialized.current = false;
		};
	}, [isLogin, websocketInitialized]);
	 for dev version => end */
	
	
	
	return (
		<div className="oversite">
			<Suspense fallback={<div>Loading...</div>}>
				{isLogin && <ChatWindow/>}
			</Suspense>
			<NavBar />
			<Routes>
				{/* Public routes */}
				<Route path="/about" element={<About/>} />
				<Route path="/gettoknow" element={<Gettoknow/>} />
				<Route path="/contractors" element={<Contractors/>} />
				<Route path="/solutions" element={<Solutions/>} />
				<Route path="/contacts" element={<Contact/>} />
				<Route path="/" element={<Main/>} />
				<Route path="/login" element={<Main/>} />
				<Route path="/forgot" element={<Forgot />} />

				{/* Protected routes */}
				<Route element={<ProtectedRoute />}>
					<Route path="/lk" element={<Lkabinet />} />
					<Route path="/lk/dashboard" element={<LkDashboard />} />
					<Route path="/lk/notification" element={<LkNotification />} />
					<Route path="/risk" element={<Risk />} />
					<Route path="/myrisk" element={<MyRisk />} />
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/risktable" element={<RiskTable />} />
					<Route path="/risktable2" element={<RiskTable />} />
					<Route path="/templates" element={<Templates />} />
					<Route path="/reviewrisktable" element={<ReviewRiskTable />} />
				</Route>
				{/* Fallback Route */}
				<Route path="*" element={<Navigate to="/" />} />
			</Routes>
			<Footer/>
		</div>
	)
}
export default App;